import axios, { AxiosResponse } from "axios";
import { CurrentUser } from "../../models/User";

const getCurrentUserDetails = () => async (): Promise<AxiosResponse<CurrentUser>> => {
	return await axios.get(`/api/v1/user/details`);
};

export { getCurrentUserDetails };
